import { Drawer, Dropdown, Tooltip } from "antd";
import { GiHamburgerMenu } from "react-icons/gi";
import { GrClose } from "react-icons/gr";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import useMedia from "use-media";

import { AuthAction, DashboardAction } from "../../store/actions";
import { Button } from "../../components";
import { Colors, Fonts, Images } from "../../config";
import ProfileDropDown from "./dropdown.js";
import warning from '../../assets/images/warning.png'
import profile from '../../assets/images/profile.png'
import dashboardIcon from '../../assets/images/dashboardIcon.png'
import userManagementIcon from '../../assets/images/userManagementIcon.png'
import providerManagementIcon from '../../assets/images/providerManagementIcon.png'
import serviceManagementIcon from '../../assets/images/serviceManagmentIcon.png'
import reportManagementIcon from '../../assets/images/reportManagementIcon.png'
import disputeManagementIcon from '../../assets/images/disputeManagementIcon.png'
import jobManagementIcon from '../../assets/images/jobManagementIcon.png'
import contactSupportIcon from '../../assets/images/contactSupportIcon.png'
import adsManagementIcon from '../../assets/images/adsManagementIcon.png'
import subAdminManagementIcon from '../../assets/images/subAdminManagementIcon.png'
import logoWhiteBg from '../../assets/images/logoWhiteBg.png'
import analytics from '../../assets/images/analytics.png'
import booking from '../../assets/images/booking.png'
import notificationIcon from '../../assets/images/bellIconn.png'
import "./navHeader.css";

const NavHeader = ({ isCollapsed }) => {
  let adminRole;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const authUser = useSelector((state) => state.auth.user);
  const count = useSelector((state) => state?.dashboard?.count?.data?.data?.uploadedDocumentsCount);

  if (authUser?.user) {
    adminRole = authUser?.user?.roleId;
  } else {
    const authLS = JSON.parse(localStorage.getItem("authUser"));
    adminRole = authLS?.user?.roleId;
  }

  const isTablet = useMedia({ minWidth: "770px" });
  const isMobile = useMedia({ minWidth: "500px" });

  const showDrawer = () => {
    setVisible(true);
  };

  const showName = (name) => {
    return name.length > 10 ? `${name.slice(0, 10)}...` : name;
  };

  const onClose = () => {
    setVisible(false);
  };
  const user = useSelector((state) => state.auth.user);
  const userLS = JSON.parse(localStorage.getItem("authUser"));
  const title = ((location || {}).pathname || {}).split("/")[1];
  console.log(title)
  const handleLogout = () => {
    dispatch(AuthAction.logout());
  };

  useEffect(() => {
    dispatch(DashboardAction.getCount())
  }, []);

  const Hamburger = ({ placement }) => (
    <>
      <div className="nav-header-mobile" onClick={showDrawer}>
        <GiHamburgerMenu
          style={{
            color: Colors.White,
            fontSize: "30px",
          }}
          className="hamburger-menu"
        />
      </div>
      <Drawer
        closeIcon={false}
        title=""
        placement={placement}
        onClose={onClose}
        visible={visible}
        width={isMobile ? 378 : 320}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between", //isMobile ? "flex-start" : "flex-end",
            alignItems: "center",
            paddingLeft: isMobile ? "15px" : "0px",
            paddingRight: isMobile ? "0px" : "15px",
            marginBottom: "20px",
          }}
        >
          {!isMobile ? (
            <>
              <GrClose fontSize={24} onClick={onClose} />
              <img src={Images.Logo} />
            </>
          ) : (
            <>
              <img src={Images.Logo} />
            </>
          )}
        </div>
        <div className="mobile-navbar">
          <ul>
            <li
              className={title === "dashboard" && "selected"}
              onClick={() => {
                setVisible(false);
                navigate("dashboard");
              }}
            >
              Dashboard
            </li>
            <li
              className={title === "user-management" && "selected"}
              onClick={() => {
                setVisible(false);
                navigate("user-management");
              }}
            >
              User Management
            </li>
            <li
              className={title === "provider-management" && "selected"}
              onClick={() => {
                setVisible(false);
                navigate("provider-management");
              }}
            >
              Provider Management
            </li>
            <li
              className={title === "service-management" && "selected"}
              onClick={() => {
                setVisible(false);
                navigate("service-management");
              }}
            >
              Service Management
            </li>
            <li
              className={title === "reports-management" && "selected"}
              onClick={() => {
                setVisible(false);
                navigate("reports-management");
              }}
            >
              Reports Management
            </li>
            <li
              className={title === "promo-management" && "selected"}
              onClick={() => {
                setVisible(false);
                navigate("promo-management");
              }}
            >
              Promo Management
            </li>

            {!isMobile && (
              <>
                <li
                  className={title === "contact-support" && "selected"}
                  onClick={() => {
                    setVisible(false);
                    navigate("contact-support");
                  }}
                >
                  Contact Support
                </li>
                <li
                  className={title === "notification-management" && "selected"}
                  onClick={() => {
                    setVisible(false);
                    navigate("notification-management");
                  }}
                >
                  Notification Management
                </li>
                {adminRole === 2 && (
                  <li
                    className={title === "sub-admin-management" && "selected"}
                    onClick={() => {
                      setVisible(false);
                      navigate("sub-admin-management");
                    }}
                  >
                    Sub-Admin
                  </li>
                )}
              </>
            )}

          </ul>
          {!isMobile && (
            <Button.Basic
              variant="outlined"
              style={{
                backgroundColor: Colors.Black,
                textTransform: "capitalize",
                color: Colors.White,
                width: "100%",
                borderRadius: 5,
                borderColor: Colors.Transparent,
                fontFamily: `${Fonts["Poppins-Regular"]}`,
              }}
              startIcon={<img src={Images.LogoutIcon} />}
              onClick={handleLogout}
              text="Logout"
              size="large"
            />
          )}
        </div>
      </Drawer>
    </>
  );

  return (
    <div className="nav-header-container">
      {/* <div className="upper-navbar">
        <div>
          <img src={Images.DashboardLogo} />
        </div>
        <div className="site-layout-background-right">
          <div
            className="profile"
            style={{
              width:
                adminRole === 2
                  ? isTablet
                    ? "max-content"
                    : isMobile
                      ? "max-content"
                      : "50px"
                  : isTablet
                    ? "max-content"
                    : isMobile
                      ? "max-content"
                      : "50px",
            }}
          >
            {isMobile ? (
              <>
                {isTablet ? (
                  <span className="mr-10">{`Welcome Back, ${adminRole === 2 ? "Admin!" : "Sub Admin!"
                    }`}</span>
                ) : null}
                <img
                  src={user?.imageUrl || profile}
                  alt=""
                  className="w-full h-full rounded-full"
                />
                <span className="mx-10">
                  {user.user !== undefined
                    ? showName(user?.user?.fullName)
                    : showName(userLS?.user?.fullName)}
                </span>
                <Dropdown
                  overlay={<ProfileDropDown />}
                  style={{ top: "65px !important" }}
                >
                  <a
                    className="ant-dropdown-link"
                    onClick={(e) => e.preventDefault()}
                  >
                    <img src={Images.DropdownIcon} height={5} alt="disappear" />
                  </a>
                </Dropdown>
              </>
            ) : (
              <Hamburger placement={"right"} />
            )}
          </div>
        </div>
      </div> */}
      <div className="lower-navbar">
        <ul>
          <li
            onClick={() => navigate("dashboard")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "dashboard" && "selected"} navbar-icon`}>
                    <img src={dashboardIcon} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "dashboard" && "selected"} navbar-icon`}>
                    <img src={dashboardIcon} width={20} height={20} />
                  </div>
                  Dashboard
                </>
            }
          </li>
          <li
            onClick={() => navigate("user-management")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "user-management" && "selected"} navbar-icon`}>
                    <img src={userManagementIcon} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "user-management" && "selected"} navbar-icon`}>
                    <img src={userManagementIcon} width={20} height={20} />
                  </div>
                  User Management
                </>
            }
          </li>

          {/* <li
            className={title === "provider-management" && "selected"}
            onClick={() => navigate("provider-management")}
          >

            Provider Management {count ?
              <Tooltip placement="top" title={'Action Required On Documents'}>
                <img src={Images.Warning} alt="Image" width={'10%'} height={'10%'} style={{ marginRight: "-22px" }} />
              </Tooltip>
              : ''}

          </li> */}

          <li
            onClick={() => navigate("provider-management")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "provider-management" && "selected"} navbar-icon`}>
                    <img src={providerManagementIcon} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "provider-management" && "selected"} navbar-icon`}>
                    <img src={providerManagementIcon} width={20} height={20} />
                  </div>
                  Provider Management
                </>
            }
          </li>

          <li
            onClick={() => navigate("service-management")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "service-management" && "selected"} navbar-icon`}>
                    <img src={serviceManagementIcon} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "service-management" && "selected"} navbar-icon`}>
                    <img src={serviceManagementIcon} width={20} height={20} />
                  </div>
                  Service Management
                </>
            }
          </li>

          <li
            onClick={() => navigate("services-commission")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "services-commission" && "selected"} navbar-icon`}>
                    <img src={analytics} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "services-commission" && "selected"} navbar-icon`}>
                    <img src={analytics} width={20} height={20} />
                  </div>
                  Service Commission Management
                </>
            }
          </li>

          <li
            onClick={() => navigate("reports-management")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "reports-management" && "selected"} navbar-icon`}>
                    <img src={reportManagementIcon} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "reports-management" && "selected"} navbar-icon`}>
                    <img src={reportManagementIcon} width={20} height={20} />
                  </div>
                  Reports Management
                </>
            }
          </li>

          {/* <li
            onClick={() => navigate("promo-management")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "promo-management" && "selected"} navbar-icon`}>
                  <img src={reportManagementIcon} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "promo-management" && "selected"} navbar-icon`}>
                  <img src={reportManagementIcon} width={20} height={20} />
                  </div>
                  Promo Management
                </>
            }
          </li> */}

          <li
            onClick={() => navigate("dispute-management")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "dispute-management" && "selected"} navbar-icon`}>
                    <img src={disputeManagementIcon} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "dispute-management" && "selected"} navbar-icon`}>
                    <img src={disputeManagementIcon} width={20} height={20} />
                  </div>
                  Dispute Management
                </>
            }
          </li>

          <li
            onClick={() => navigate("/job-management")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "job-management" && "selected"} navbar-icon`}>
                    <img src={jobManagementIcon} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "job-management" && "selected"} navbar-icon`}>
                    <img src={jobManagementIcon} width={20} height={20} />
                  </div>
                  Job Management
                </>
            }
          </li>
          <li
            onClick={() => navigate("ad-management")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "ad-management" && "selected"} navbar-icon`}>
                    <img src={adsManagementIcon} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "ad-management" && "selected"} navbar-icon`}>
                    <img src={adsManagementIcon} width={20} height={20} />
                  </div>
                  Ad Management
                </>
            }
          </li>
          <li
            onClick={() => navigate("contact-support")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "contact-support" && "selected"} navbar-icon`}>
                    <img src={contactSupportIcon} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "contact-support" && "selected"} navbar-icon`}>
                    <img src={contactSupportIcon} width={20} height={20} />
                  </div>
                  Contact Support
                </>
            }
          </li>

          <li
            onClick={() => navigate("notification-management")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "notification-management" && "selected"} navbar-icon`}>
                    <img
                      src={notificationIcon}
                      width={25}
                      height={25}
                      style={{ filter: "brightness(0) invert(0.72)" }}
                      alt=""
                    />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "notification-management" && "selected"} navbar-icon`}>
                    <img
                      src={notificationIcon}
                      width={20}
                      height={20}
                      style={{ filter: "brightness(0) invert(0.72)" }}
                      alt=""
                    />
                  </div>
                  Notification Management
                </>
            }
          </li>

          <li
            onClick={() => navigate("sub-admin-management")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "sub-admin-management" && "selected"} navbar-icon`}>
                    <img src={subAdminManagementIcon} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "sub-admin-management" && "selected"} navbar-icon`}>
                    <img src={subAdminManagementIcon} width={20} height={20} />
                  </div>
                  Sub-Admin
                </>
            }
          </li>

          <li
            onClick={() => navigate("booking-management")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${(title === "booking-management" || title.startsWith("booking-detail")) ? "selected" : ""} navbar-icon`} >
                    <img src={booking} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${(title === "booking-management" || title.startsWith("booking-detail")) ? "selected" : ""} navbar-icon`} >
                    <img src={booking} width={20} height={20} />
                  </div>
                  Booking Managements
                </>
            }
          </li>

          <li
            onClick={() => navigate("analysis")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "analysis" && "selected"} navbar-icon`}>
                    <img src={analytics} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "analysis" && "selected"} navbar-icon`}>
                    <img src={analytics} width={20} height={20} />
                  </div>
                  Provider and User Analytics
                </>
            }
          </li>


          {/* <li
            onClick={() => navigate("settings")}
            className={isCollapsed ? 'collapsed-li' : 'un-collapsed-li'}
          >
            {
              isCollapsed ?
                <>
                  <div className={`${title === "settings" && "selected"} navbar-icon`}>
                    <img src={analytics} width={25} height={25} />
                  </div>
                </>
                :
                <>
                  <div className={`${title === "settings" && "selected"} navbar-icon`}>
                    <img src={analytics} width={20} height={20} />
                  </div>
                  settings
                </>
            }
          </li> */}

        </ul>
        {/* {isMobile && (
          <>
            <Hamburger placement={"left"} />
            <Button.Basic
              variant="outlined"
              style={{
                backgroundColor: Colors.Black,
                textTransform: "capitalize",
                color: Colors.White,
                width: "100%",
                borderRadius: 5,
                borderColor: Colors.Transparent,
                fontFamily: `${Fonts["Poppins-Regular"]}`,
              }}
              startIcon={<img src={Images.LogoutIcon} />}
              onClick={handleLogout}
              text="Logout"
              containerStyle={{ margin: "10px 0" }}
              size="large"
            />
          </>
        )} */}
      </div>
    </div>
  );
};
export default NavHeader;
